import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CountryDto, StateDto} from '@cradua/data';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-state-container',
  templateUrl: './state-container.component.html',
  styleUrls: ['./state-container.component.scss']
})
export class StateContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  countries$: Observable<CountryDto[]>;
  states$: Observable<StateDto[]>;
  loading: boolean;
  isLoadingCountry$: Observable<boolean>;
  isLoadingState$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingCountry$ = this.gatwayFacade.isLoadingGateway("Country");
    this.isLoadingState$ = this.gatwayFacade.isLoadingGateway("State");

    this.countries$ = this.gatwayFacade.loadGateway("Country");
    this.states$ = this.gatwayFacade.loadGateway("State");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteState(deletedValue: any) {
    this.gatwayFacade.remove("State", deletedValue);
  }

// this method control both the create and update
  onSubmitState(formValue: any) {
    const pullData = formValue.States;

// declare two empty array to hold update and create data
  const allUpdates = [] ;
  const addAllState = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      addAllState.push(pullData[i]);
    }
  }

// check if the addAllCountry array is not empty, then dispatch the data to the store
   if(addAllState.length > 0) {
    this.gatwayFacade.add('Country', addAllState);
   }

// dispatch update data to the store
   if(allUpdates.length > 0) {
    this.gatwayFacade.update('State', allUpdates, ['id']);
   }
  }


}
